<template>
  <v-dialog v-model="modal_loading.visible" hide-overlay persistent width="400">
    <v-card color="primary" dark>
      <v-card-text style="padding-top: 10px;">
        {{ modal_loading.text }}
        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'LayoutModalLoading',
  data () {
    return {
      modal_loading: {
        visible: false,
        text: null
      },
    }
  },
  methods: {
    onEvent ({ text }) {
      if (text === false) {
        this.modal_loading.visible = false
        this.modal_loading.text = null
      } else {
        this.modal_loading.visible = true
        this.modal_loading.text = text
      }
    }
  },
  mounted () {
    this.$bus.on('ui/modal_loading', this.onEvent)
  },
  destroyed() {
    this.$bus.off('ui/modal_loading', this.onEvent)
  }
}
</script>

<style scoped>

</style>